<template>
  <div class="row">
    
    <div class="col-md-12">
      <div class="col-lg-12 text-center">
        <h2>Please fill in the form below</h2>
      </div>

      <card class="stacked-form">
        <form @submit.prevent>
          <div class="row">
            <div class="col-md-4 ml-auto mr-auto">
                <h3 style="border-bottom: solid red">Employee Management</h3>
                <base-input label="Shift Code ID" placeholder="Shift Code ID" v-model="ShiftCodeID">
                </base-input>
                <base-input label="Clock In">
                    <el-time-picker 
                    v-model="ClockIn"
                    value-format="HH:mm"
                        :picker-options="{
                        format: 'hh:mm'
                    }"
                    placeholder="Clock In"
                    ></el-time-picker>

                <!-- <el-time-select 
                    :picker-options="{
                    start:'00:00', 
                    step:'00:01',
                    end:'23:59'
                    }" 
                    placeholder="Clock In" v-model="ClockIn "
                ></el-time-select> -->
                </base-input>
                <base-input label="Clock Out">
                    <el-time-picker 
                    v-model="ClockOut"
                    value-format="HH:mm"
                        :picker-options="{
                        format: 'hh:mm'
                    }"
                    placeholder="Clock Out"
                    ></el-time-picker>
                </base-input>
            </div>
          </div>
        </form>
      </card>
      <div class="col-lg-12 text-center">
        <base-button
          class="mt-3"
          native-type="submit"
          type="primary"
          @click="addShiftCode()"
          >Submit</base-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import { BaseCheckbox, BaseRadio } from "src/components/index";
import { Select, Option, TimeSelect, TimePicker, DatePicker } from "element-ui";
import { touches } from "d3";
import swal from "sweetalert2";
import moment from "moment";

export default {
  components: {
    BaseCheckbox,
    [Select.name]: Select,
    [Option.name]: Option,
    BaseRadio,
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
    [TimePicker.name]: TimePicker
  },
  data() {
    return {
        ClockIn: "",
        ClockOut: "",
        ShiftCodeID: "",
    };
  },
  mounted() {
  },
  created(){
  },
  methods: {
    addShiftCode(){
      console.log(moment(this.ClockOut,'H:mm').format('H:mm'))
     
      if (this.ClockOut === "" || this.ClockIn === "" || this.ShiftCodeID === ""){
        swal({
          type: "error",
          title: "Oops... form cannot be empty!"
        });
      } else {
        // send
        let payload = {
          ShiftCodeID: this.ShiftCodeID,
          ClockIn: moment(this.ClockIn, 'H:mm').format("H:mm"),
          ClockOut: moment(this.ClockOut, 'H:mm').format("H:mm")
        }
        console.log(payload)

        this.$http.post(":9995/api/v1/manage/shift", payload)
          .then(res =>{
            if(!res.error){
              let data = res.message
              console.log(data)
              swal({
                title: "Successful!",
                text: res.message,
                type: "success",
                confirmButtonClass: "btn btn-success btn-fill",
                confirmButtonText: "Okay",
                buttonsStyling: false
              });
              this.modals2 = false
              this.ShiftCodeID = ""
              this.ClockIn = ""
              this.ClockOut = ""
              this.$router.push("/attendance/ShiftCodeManagement");
            } else {
              swal({
                title: "Data Error!",
                text: `${res.message}`,
                type: "warning",
                confirmButtonClass: "btn btn-success btn-fill",
                confirmButtonText: "Okay",
                buttonsStyling: false
              });
            }
          })
      }
    }
    
    
  }
};
</script>
<style lang="scss">
.address {
  width: 100%;
  height: 100px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  font-size: 14px;
  resize: none;
}
</style>
